(function () {
  "use strict";

  function padNumber(number) {
    return String(number).padStart(2, "0");
  }

  function getProductScope(timer) {
    return (
      timer.closest(
        "product-information, product-info, .product-information, .product-details, .product-card, .card, .shopify-section"
      ) || document
    );
  }

  function disableProductPurchase(timer) {
    const scope = getProductScope(timer);

    const addToCartButtons = scope.querySelectorAll(
      'button[name="add"], .add-to-cart-button, [data-testid="standalone-add-to-cart"], [id^="BuyButtons-ProductSubmitButton"]'
    );

    addToCartButtons.forEach(function (button) {
      button.disabled = true;
      button.setAttribute("disabled", "disabled");
      button.setAttribute("aria-disabled", "true");
      button.classList.add("drop-ended-button");

      const buttonText = button.querySelector(
        ".add-to-cart-text__content"
      );

      const buttonIcon = button.querySelector(
        ".add-to-cart-icon"
      );

      if (buttonText) {
        buttonText.textContent = "Drop Ended";
      } else {
        button.textContent = "Drop Ended";
      }

      if (buttonIcon) {
        buttonIcon.style.display = "none";
      }
    });

    const checkoutButtons = scope.querySelectorAll(
      ".shopify-payment-button, shopify-accelerated-checkout, [data-shopify='payment-button']"
    );

    checkoutButtons.forEach(function (element) {
      element.style.display = "none";
    });

    const productForms = scope.querySelectorAll(
      'form[action*="/cart/add"]'
    );

    productForms.forEach(function (form) {
      if (form.dataset.dropEndedBound === "true") {
        return;
      }

      form.dataset.dropEndedBound = "true";

      form.addEventListener(
        "submit",
        function (event) {
          if (timer.classList.contains("is-ended")) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        },
        true
      );
    });
  }

  function updateTimer(timer) {
    const endTimeSeconds = Number(timer.dataset.endTime);

    if (!endTimeSeconds) {
      return;
    }

    const remainingMilliseconds =
      endTimeSeconds * 1000 - Date.now();

    const activeContent = timer.querySelector(
      "[data-drop-active]"
    );

    const endedContent = timer.querySelector(
      "[data-drop-ended]"
    );

    if (remainingMilliseconds <= 0) {
      timer.classList.add("is-ended");

      if (activeContent) {
        activeContent.hidden = true;
      }

      if (endedContent) {
        endedContent.hidden = false;
      }

      disableProductPurchase(timer);
      return;
    }

    timer.classList.remove("is-ended");

    if (activeContent) {
      activeContent.hidden = false;
    }

    if (endedContent) {
      endedContent.hidden = true;
    }

    const totalSeconds = Math.floor(
      remainingMilliseconds / 1000
    );

    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor(
      (totalSeconds % 86400) / 3600
    );
    const minutes = Math.floor(
      (totalSeconds % 3600) / 60
    );
    const seconds = totalSeconds % 60;

    const daysElement = timer.querySelector("[data-days]");
    const hoursElement = timer.querySelector("[data-hours]");
    const minutesElement = timer.querySelector("[data-minutes]");
    const secondsElement = timer.querySelector("[data-seconds]");

    if (daysElement) {
      daysElement.textContent = padNumber(days);
    }

    if (hoursElement) {
      hoursElement.textContent = padNumber(hours);
    }

    if (minutesElement) {
      minutesElement.textContent = padNumber(minutes);
    }

    if (secondsElement) {
      secondsElement.textContent = padNumber(seconds);
    }
  }

  function updateAllTimers() {
    document
      .querySelectorAll("[data-drop-timer]")
      .forEach(updateTimer);
  }

  function initializeDropTimers() {
    updateAllTimers();

    if (!window.dropTimerInterval) {
      window.dropTimerInterval = window.setInterval(
        updateAllTimers,
        1000
      );
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeDropTimers
    );
  } else {
    initializeDropTimers();
  }

  document.addEventListener(
    "shopify:section:load",
    updateAllTimers
  );
})();